import { ErrorEvent, EventHint } from '@sentry/react';
import { isChannelRequestEvent } from './channelRequestFingerprint';

/** Share of ordinary error events sent to Sentry (formerly the SDK's `sampleRate`). */
export const SENTRY_ERROR_SAMPLE_RATE = 0.5;

/**
 * Keeps every service worker request failure and diagnostics report: they are
 * rare and capped by the page, and losing half of them hides the cause of a
 * stuck spinner. Other errors are sampled as before.
 */
export function shouldKeepSentryEvent(
  event: ErrorEvent,
  hint?: EventHint,
  random: () => number = Math.random
): boolean {
  return isChannelRequestEvent(event, hint) || random() < SENTRY_ERROR_SAMPLE_RATE;
}
